// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_2sjK6","button":"view-header_button_1gJ0b","active":"view-header_active_7dEc-","btnExport":"view-header_btnExport_1Vm_6","mr":"view-header_mr_swBVO"};